/**
 * SEO landing pages for broadcast categories (guests / search engines only).
 * Authenticated users are redirected to /broadcasts?listType=...
 *
 * categoryPath must match broadcastMap[].path and content keys
 * (broadcastCategoryDescriptions / frequentlyAskedQuestions).
 */
export const broadcastSeoLandings = {
  laptop: {
    categoryPath: 'laptop',
    listType: '7',
    seoSlug: 'broadcasts-refurbished-laptops',
    legacyPath: 'laptop',
    routeName: 'broadcastsLaptopSeo',
    h1: 'Newest Broadcasts for Refurbished Laptops',
    intro: 'Our platform connects professional buyers and sellers of refurbished laptops, creating a marketplace where businesses can source, buy, and sell laptop inventory in bulk. Whether you are looking for ex-corporate lease returns, used laptops for refurbishment, graded laptop stock, or ready-to-sell refurbished devices, you can discover inventory from trusted suppliers across Europe and international markets.',
    title: 'B2B offers for refurbished Laptops, from Suppliers to Resellers',
    description: 'Newest TBS-Broadcast: B2B offers for refurbished Laptops, directly from large quanity lots from Suppliers to used electronics to resellers & online shop owners',
    keywords: 'Newest Broadcasts for Refurbished Laptops, B2B, refurbished laptops, WTB, WTS, suppliers, resellers, The Broker Site',
  },
  'server-storage': {
    categoryPath: 'server-storage',
    listType: '2',
    seoSlug: 'broadcasts-refurbished-servers',
    legacyPath: 'server-storage',
    routeName: 'broadcastsServersSeo',
    h1: 'Newest Broadcasts for Refurbished Servers',
    intro: 'Our platform connects professional buyers and sellers of refurbished servers and storage, creating a marketplace where businesses can source, buy, and sell enterprise hardware in bulk. Whether you need ex-lease rack servers, storage arrays for refurbishment, graded data-center lots, or ready-to-deploy systems, you can discover inventory from trusted suppliers and wholesalers across Europe and international markets.',
    title: 'B2B offers for refurbished Servers & Storage, from Suppliers to Resellers',
    description: 'Newest TBS-Broadcast: B2B offers for refurbished Servers and storage, from suppliers and wholesalers to resellers, brokers & data center buyers',
    keywords: 'Newest Broadcasts for Refurbished Servers, B2B, refurbished servers, storage, WTB, WTS, wholesalers, The Broker Site',
  },
}

export function getSeoLandingBySlug(seoSlug) {
  return Object.values(broadcastSeoLandings).find(landing => landing.seoSlug === seoSlug) || null
}

export function getSeoLandingByCategoryPath(categoryPath) {
  return broadcastSeoLandings[categoryPath] || null
}

export function buildSeoLandingCanonical(landing, type) {
  const base = `https://www.thebrokersite.com/${landing.seoSlug}`
  const normalized = type ? type.toLowerCase() : null
  if (normalized === 'wtb' || normalized === 'wts') {
    return `${base}/${normalized}`
  }
  return base
}

export function buildSeoLandingRoutes(Broadcasts, store) {
  const routes = []

  Object.values(broadcastSeoLandings).forEach(landing => {
    routes.push({
      path: `/broadcasts/${landing.legacyPath}/:type(wtb|wts)?`,
      redirect: to => {
        const type = to.params.type?.toLowerCase()
        return type
          ? `/${landing.seoSlug}/${type}`
          : `/${landing.seoSlug}`
      },
    })

    routes.push({
      path: `/${landing.seoSlug}/:type(wtb|wts)?`,
      name: landing.routeName,
      component: Broadcasts,
      beforeEnter(to, from, next) {
        if (!store.state.user) {
          store.commit('bootstrapUserFromLocalStorage')
        }
        if (store.state.user) {
          const query = { listType: landing.listType }
          const type = to.params.type?.toLowerCase()
          if (type === 'wtb') query.type = 'WTB'
          if (type === 'wts') query.type = 'WTS'
          return next({ path: '/broadcasts', query, replace: true })
        }

        const metaCanonical = to.meta.metaTags?.find(tag => tag.rel === 'canonical')
        if (metaCanonical) {
          metaCanonical.href = buildSeoLandingCanonical(landing, to.params.type)
        }
        next()
      },
      meta: {
        seoLanding: true,
        broadcastCategory: landing.categoryPath,
        listType: landing.listType,
        seoSlug: landing.seoSlug,
        h1: landing.h1,
        intro: landing.intro,
        title: landing.title,
        metaTags: [
          { name: 'description', content: landing.description },
          { name: 'keywords', content: landing.keywords },
          {
            name: 'robots',
            content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
          },
          {
            rel: 'canonical',
            href: `https://www.thebrokersite.com/${landing.seoSlug}`,
          },
        ],
      },
    })
  })

  return routes
}
